































































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { mailSchedule } from '../store/modules/MailSchedule'; // ストアモジュール
import { KanriConstants } from '../fixed/KanriConstants';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import axios from 'axios';
import { loadingControlModule } from '../../store/modules/LoadingControl';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.10.31 [2023L-08] add
 */
@Component
export default class MailScheduleSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)
  // 検索結果ヘッダの設定
  private headers = [{}];
  // ボタン表示設定
  private deleteAuthority: boolean = this.checkAuthority(AuthoritiesId.MSS_DELETE);
  private createAuthority: boolean = this.checkAuthority(AuthoritiesId.MSS_CREATE);
  private updateAuthority: boolean = this.checkAuthority(AuthoritiesId.MSS_UPDATE);

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'メール送信スケジュール管理';
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_schedule_search_condition']);
    const path: string = KanriConstants.MAIL_SCHEDULE_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 先頭の空白列削除
        this.headers.shift();
        // ボタン用ヘッダ
        this.headers.push(
        {text: '削除', align: 'center', sortable: false, value: 'delete', width: 90},
        {text: '複写', align: 'center', sortable: false, value: 'copy', width: 90},
        );
        // 検索結果.DBから展開
        for (const item of this.variablecols['mail_schedule_search_result'] ) {
          this.headers.push({text: item.label,
                            align: item.align,
                            sortable: item.sortable,
                            value: item.name,
                            width: item.width,
                            } );
        }
        // 再検索
        if (mailSchedule.GET_IS_FORM_CONDITION_SETTING) {
          this.formData = mailSchedule.GET_FORM_CONDITION;
          this.syncFormDataToVariableCols();
          // 業者種別の復元
          if (this.formData.paramsTraderType !== '') {
            this.getNendoOptions(this.formData.paramsTraderType, this.formData.paramsNendo);
          }
          this.search();
        }
      }
    });
  }
  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    mailSchedule.moduleReset();
    router.push({ name: 'kanri-top' });
  }
  /**
   * 検索
   */
  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        mailSchedule.setFormCondition(this.formData);
        // 検索一覧の先頭へジャンプ
        this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('mailScheduleSearch', -50);
      }
    });
  }
  /**
   * 登録画面への遷移
   */
  private addData() {
    router.push({ name: 'mailScheduleInfo' });
  }
  /**
   * データの削除
   * @param argScheduleId
   */
  private deleteData(argScheduleId: string) {
    if (window.confirm(Message.I0001)) {
      mailSchedule.setScheduleId(argScheduleId);
      // APIアクセス
      this.apiAccess(
        KanriConstants.MAIL_SCHEDULE_PATH + '/delete' + mailSchedule.GET_PATH
           , Constants.API_METHOD_POST, false, null)
      .then((result) => {
        // キー情報削除
        mailSchedule.moduleSelectReset();
        this.hrefElement('mailScheduleSearch', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          // 結果から削除したデータを削除
          for (const rowIndex of Object.keys(this.resultData)) {
            if (this.resultData[Number(rowIndex)]['scheduleId'] === argScheduleId) {
              this.resultData.splice(Number(rowIndex), 1);
              return;
            }
          }
        }
      });
    }
  }
  /**
   * データの複写
   * @param argScheduleId
   */
  private copyData(argScheduleId: string) {
    mailSchedule.setScheduleId(argScheduleId);
    mailSchedule.setDataCopy(true);
    router.push({ name: 'mailScheduleInfo' });
  }
  /**
   * データの編集
   * @param argScheduleId
   */
  private editData(argScheduleId: string) {
    mailSchedule.setScheduleId(argScheduleId);
    if (this.updateAuthority) {
      this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + mailSchedule.GET_EXCLUSIVE_PATH, Constants.API_METHOD_POST, false, null)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          router.push({ name: 'mailScheduleInfo' });
        } else {
          // キー情報削除
          mailSchedule.moduleSelectReset();
          this.hrefElement('mailScheduleSearch', -50);
        }
      });
    } else {
      router.push({ name: 'mailScheduleInfo' });
    }
  }
  /**
   * 業者種別変更
   * @pram value
   */
  private traderTypeSwitch(value: string) {
    this.getNendoOptions(value, '');
  }
  /**
   * 年度リスト取得
   */
  private getNendoOptions(traderType: string, nendo: string) {
    if (traderType === '') {
      this.setNendoOptions([], nendo);
      return;
    }
    loadingControlModule.startLoading();
    axios.get(KanriConstants.MAIL_SCHEDULE_PATH + '/nendo/' + traderType)
    .then((response) => {
      this.setNendoOptions(response.data, nendo);
    }).catch((error) => {
        this.hrefElement('mailScheduleSearch', -50);
        this.setNendoOptions([], nendo);
        this.errorMessage += error.response.data.code + ':' + error.response.data.message + '\n';
    }).finally(() => {
      loadingControlModule.endLoading();
    });
  }
  /**
   * 年度リスト設定
   * @param list
   */
  private setNendoOptions(list: any, value: string) {
    const obj = this.getVariablecol('mail_schedule_search_condition', 'paramsNendo');
    obj.options = list;
    obj.value = value;
    //labelが変動しないとoptionsの変更が反映されない？
    const tempLabel = obj.label;
    obj.label = '';
    obj.label = tempLabel;
  }
}
